import React from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';

import './index.scss';
import './helpers/globalAuth';
import './i18n';

import { HelmetProvider } from 'react-helmet-async';
import Routes from './routes';

// Suppress ResizeObserver errors globally (common with tooltips and dynamic content)
const suppressResizeObserverErrors = () => {
  const errorHandler = (e) => {
    if (
      e.message?.includes('ResizeObserver loop') ||
      e.message === 'ResizeObserver loop limit exceeded'
    ) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
    return undefined;
  };

  const unhandledRejectionHandler = (e) => {
    if (
      e.reason?.message?.includes('ResizeObserver loop') ||
      e.reason === 'ResizeObserver loop limit exceeded'
    ) {
      e.preventDefault();
      return false;
    }
    return undefined;
  };

  window.addEventListener('error', errorHandler);
  window.addEventListener('unhandledrejection', unhandledRejectionHandler);
};

suppressResizeObserverErrors();

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Routes />
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
